// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6e051b21","143":"74901d0e","492":"d1b041e5","670":"b48d06ac","719":"14930064","728":"4af62a7e","917":"adf7c16e","931":"dc56c644"}[chunkId] + ".chunk.js";
};